import { useState, useEffect, useCallback } from "react";
import { getKpiForPeriod } from "../pages/KpiDashboard/kpiDataHelpers";
import type { KpiDashboardData, SelectedPeriod } from "../types/kpiDashboard";

const initialData: KpiDashboardData = {
  weeklyTrend:    [],
  anomalyTrend:   [],
  invoiceTrend:   [],
  currentWeek:    null,
  prevWeek:       null,
  overdueInvoices:[],
  failures:       [],
  marketing:      { adsCostThisMonth: 0, adsCostPrevMonth: 0, totalMarketingCost: 0 },
  lastUpdated:    "",
};

export const useKpiDashboard = (selectedPeriod: SelectedPeriod) => {
  const [data, setData]           = useState<KpiDashboardData>(initialData);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError]         = useState<string | null>(null);

  const fetchKpiData = useCallback(async () => {
    if (!selectedPeriod.year || !selectedPeriod.week) return;
    setIsLoading(true);
    setError(null);
    try {
      const result = await getKpiForPeriod(selectedPeriod.year, selectedPeriod.week);
      setData(result);
    } catch (err) {
      setError("Failed to load KPI data. Please try again.");
      console.error("useKpiDashboard error:", err);
    } finally {
      setIsLoading(false);
    }
  }, [selectedPeriod.year, selectedPeriod.week]);

  useEffect(() => {
    fetchKpiData();
  }, [fetchKpiData]);

  return { data, isLoading, error, fetchKpiData };
};
